<pxb-drawer-layout variant="temporary" width="300" (backdropClick)="closeDrawer()">
  <pxb-drawer pxb-drawer [open]="drawerOpen">
    <pxb-drawer-header title="The Log Church">
      <button pxb-icon mat-icon-button (click)="closeDrawer()">
        <mat-icon>menu</mat-icon>
      </button>
    </pxb-drawer-header>
    <pxb-drawer-body>
      <pxb-drawer-nav-item hidePadding=true title="Discipleship Path Overview"
        [selected]="selectedItemId === 'overview'"
        (select)="setActive('overview'); navigate('overview'); closeDrawer();">
      </pxb-drawer-nav-item>
      <pxb-drawer-nav-item hidePadding=true title="Assessment" [selected]="selectedItemId === 'assessment'"
        (select)="setActive('assessment'); navigate('assessment'); closeDrawer();">
      </pxb-drawer-nav-item>
      <pxb-drawer-nav-item hidePadding=true title="FAQ" [selected]="selectedItemId === 'faq'"
        (select)="setActive('faq'); navigate('faq'); closeDrawer();">
      </pxb-drawer-nav-item>
      <pxb-drawer-nav-item hidePadding=true title="Bible Path Guide" [selected]="selectedItemId === 'bible-path-guide'"
        (select)="setActive('bible-path-guide'); navigate('bible-path-guide'); closeDrawer();">
      </pxb-drawer-nav-item>
      <pxb-drawer-nav-item hidePadding=true title="Prayer Path Guide"
        [selected]="selectedItemId === 'prayer-path-guide'"
        (select)="setActive('prayer-path-guide'); navigate('prayer-path-guide'); closeDrawer();">
      </pxb-drawer-nav-item>
      <pxb-drawer-nav-item hidePadding=true title="Service Path Guide"
        [selected]="selectedItemId === 'service-path-guide'"
        (select)="setActive('service-path-guide'); navigate('service-path-guide'); closeDrawer();">
      </pxb-drawer-nav-item>
      <pxb-drawer-nav-item hidePadding=true title="Giving Path Guide"
        [selected]="selectedItemId === 'giving-path-guide'"
        (select)="setActive('giving-path-guide'); navigate('giving-path-guide'); closeDrawer();">
      </pxb-drawer-nav-item>
      <pxb-drawer-nav-item hidePadding=true title="Inviting Path Guide"
        [selected]="selectedItemId === 'inviting-path-guide'"
        (select)="setActive('inviting-path-guide'); navigate('inviting-path-guide'); closeDrawer();">
      </pxb-drawer-nav-item>

    </pxb-drawer-body>
    <pxb-drawer-footer>
      <img class="footer-image"
        src="https://thechurchco-production.s3.amazonaws.com/uploads/sites/2207/2020/04/d05e33bb-af40-43d4-9868-b372a4733dcc@2x-1.png">
      <div class="attribution-container">
        <a class="footer-text" href="https://github.com/daileytj" target="_blank" rel="noreferrer">built and maintained
          by
          Thomas Dailey</a>
      </div>
    </pxb-drawer-footer>
  </pxb-drawer>
  <div pxb-content>
    <mat-toolbar color="primary" class="toolbar">
      <button *ngIf="!drawerOpen" mat-icon-button (click)="openDrawer()" style="margin-right:16px;">
        <mat-icon>menu</mat-icon>
      </button>{{pageTitle}}
    </mat-toolbar>
    <div #scrollHack></div>
    <div class="main-content-wrapper" fxLayout="column" fxLayoutAlign="center center">
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</pxb-drawer-layout>